export default "__VITE_ASSET__000d3cf7__"